import apiUtils from '../apiUtils';

const service = {};
const serviceName = 'login';

service.login = (user, pwd, client) => {
  const body = {
    userName: user,
    password: pwd,
    IDClient: client
  };
  const removeAuth = true;
  return apiUtils.exec(serviceName, apiUtils.getFetchParameters('POST', body, removeAuth));
};

service.getResult = id => {
  return apiUtils.exec(serviceName + '/result/' + id);
};

export default service;
